import { Box, Link, Icon } from '@eriksdigital/atomic-ui/components';
import React from 'react';

import { Text } from 'app/components/atoms/Text';

import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';
import { CrossIcon } from '@eriksdigital/atomic-ui/components/Icons';
import { errorNotifyActions } from 'app/features/errorNotifications/slice';
import { useDispatch } from 'react-redux';

interface Props {
  label: string;
  translationId: string;
}

export const ErrorNotification = (props: Props) => {
  const dispatch = useDispatch();
  const { openErrorNotification } = errorNotifyActions;
  const { label, translationId } = props;
  const {
    colors: {
      default: { red },
    },
    fonts: {
      default: {
        fontWeight: { normal },
        fontSize: { ft14 },
      },
    },
  } = useTheme();

  const handleClose = () => {
    dispatch(openErrorNotification({ show: false }));
  };

  return (
    <Box
      data-testid="error-notify"
      minWidth="1168px"
      minHeight="48px"
      marginTop="sp16"
      id="error-notify"
      color="#F7D2D2"
      border-radius="3px"
    >
      <Box marginTop="sp12" marginBotton="sp12" marginLeft="sp12">
        <Box alignItems="center">
          <Box
            data-testid="cross-icon-notify"
            onClick={() => handleClose()}
            display="inline"
            marginRight="sp2"
          >
            <Icon as={CrossIcon} size="sz20" color={red} />
          </Box>
          <Text fontWeight={normal} color={red} fontSize={ft14}>
            <FormattedMessage
              id={translationId}
              defaultMessage={label}
              values={{
                ServiceNow: (
                  <Link
                    href="https://eriks.service-now.com/sp"
                    target="_blank"
                    style={{
                      textDecoration: 'underline',
                      fontWeight: 400,
                      fontSize: '14px',
                    }}
                  >
                    <FormattedMessage
                      id="service.now"
                      defaultMessage="Service Now."
                    />
                  </Link>
                ),
              }}
            />
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
